import React from "react";
import { Container } from 'react-bootstrap'
function CommonBanner({title}) {
  return (
    <>
     <div className="common-banner">
      <Container>
        <h1>{title}</h1>
      </Container>
     </div>
    </>
  )
}
export default CommonBanner